import axios from 'axios';
// export const baseUrl = "http://200.1.3.180:5030";
export const baseUrl = "https://cjpms.pubdatamall.com";
const instance = axios.create({
    baseURL: baseUrl,
    timeout: 1000000,
    headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded'
    },
    
});
const instanceresponse = axios.create({
    baseURL: baseUrl,
    timeout: 1000000,
    headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded'
    },
    responseType: 'arraybuffer'
    
});

// 下载文件
const postWrapresponse = (url, params) => {
    return new Promise((resolve, reject) => {
        instanceresponse.post(url, params).then(({data}) => {
            resolve(data)
        }).catch(err => {
            reject(err)
        })
    })
}
const postWrap = (url, params) => {
    return new Promise((resolve, reject) => {
        instance.post(url, params).then(({data}) => {
            resolve(data)
        }).catch(err => {
            reject(err)
        })
    })
}
const putWrap = (url, params) => {
    return new Promise((resolve, reject) => {
        instance.put(url, params).then(({data}) => {
            resolve(data)
        }).catch(err => {
            reject(err)
        })
    })
}

const getWrap = (url, params) => {
    return new Promise((resolve, reject) => {

        instance.get(url, { params }).then((

            {data}
        ) => resolve(data)).catch(err => reject(err));
    })
}


  // 获取申报详情
export const getgamedeclar = params => {
    const url = '/api/GameDeclareCompanyInfo/'+params;
    const Defaults = {
    }
    return getWrap(url)
  }
  // 下载报表
export const ExportExcel = baseUrl+'/api/GameDeclareCompanyInfo/ExportExcel';
 
// 批量导出列表数据

  // 添加申报企业
export const Add = params => {
    const url = '/api/GameDeclareCompanyInfo/Add';
    const Defaults = {
    }
    params = Object.assign({}, Defaults, params)
    return postWrap(url, params)
  }
// 查询审批单位列表
export const Search = params => {
    const url = '/api/GameDeclareCompanyInfo/Search';
    const Defaults = {

    }
    params = Object.assign({}, Defaults, params)
    return postWrap(url, params)
}
// 修改申报信息
export const edit = params => {
    const url = '/api/GameDeclareCompanyInfo/edit';
    const Defaults = {

    }
    params = Object.assign({}, Defaults, params)
    return putWrap(url, params)
}
// 删除报表信息
export const BatchDelete = params => {
    const url = '/api/GameDeclareCompanyInfo/BatchDelete';
    const Defaults = {

    }
    params = Object.assign({}, Defaults, params)
    return postWrap(url, params)
}
// 批量导出列表数据
export const ExportExcelAll = params => {
    const url = '/api/GameDeclareCompanyInfo/ExportExcelAll';
    const Defaults = {

    }
    params = Object.assign({}, Defaults, params)
    return postWrapresponse(url, params)
}
// 勾选导出列表数据
export const ExportExcelByIds = params => {
    const url = '/api/GameDeclareCompanyInfo/ExportExcelByIds';
    const Defaults = {

    }
    // params = Object.assign({}, Defaults, params)
    return postWrapresponse(url, params)
}
